module.exports = {
  firebaseProjectId: 'birder-dev-grzuk',
  firebaseCredentialsFile: __dirname + '/firebase-credentials-dev.json',
  firebaseApiKey: 'AIzaSyByCd-kTRGvGrl6zCs9zUHvUiOWCtbZhQE',
  firebaseStorageBucket: 'birder-dev-grzuk.firebasestorage.app',
  firestoreURL: 'https://birder-dev-grzuk-default-rtdb.firebaseio.com',
  firebaseMessageSenderId: '388768679930',
  authDomain: 'birder-dev-grzuk.firebaseapp.com',
  // Firebase Hosting custom link domain for email-link auth (dev / staging host).
  firebaseAuthEmailLinkDomain: 'test.birdergame.com',
  sentryDsn: '',
  firebaseAppId: '1:388768679930:web:381ed44c475cc8b0c00643',

  // sendLoginEmail Cloud Function (Mailtrap + Admin email link)
  loginEmailAppBaseUrl: 'https://test.birdergame.com',
  mailtrapApiKey: 'fb9d37343ee01f5c1cc79bdbedffb360',
}
